import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";

export const useFetchState = () => {

    const { data, isFetching, isPending, isError, error } = useQuery({
        queryKey: ["contractor-state"],
        queryFn: () => contractorApi.fetchState(),
    });

    return {
        data,
        isLoading: isFetching || isPending,
        isError,
        error
    };

};
